function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeter75(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 205,
    viewBox: "0 0 204 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M85.3388 93.3742L75.4027 114.218H69.4987L79.2547 94.2742H67.8067V89.5222H85.3388V93.3742Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8642 103.778L88.1122 102.806L89.9482 89.4862H104.132V94.0942H93.9802L93.2962 98.8102C94.4482 97.8382 96.1402 97.3342 97.8682 97.3342C102.584 97.3342 105.896 101.042 105.896 105.542C105.896 110.726 101.9 114.686 96.6802 114.686C91.2442 114.686 87.6082 111.374 87.5002 106.586H92.6482C92.8282 108.35 94.2322 109.862 96.6442 109.862C98.9122 109.862 100.64 108.062 100.64 105.794C100.64 103.49 98.8762 101.762 96.5722 101.762C94.9522 101.762 93.6922 102.626 92.8642 103.778Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.373 95.1382C120.373 98.4862 117.601 101.078 114.181 101.078C110.761 101.078 108.025 98.4862 108.025 95.1382C108.025 91.7902 110.761 89.1982 114.181 89.1982C117.601 89.1982 120.373 91.7902 120.373 95.1382ZM114.181 97.6222C115.585 97.6222 116.593 96.5422 116.593 95.1382C116.593 93.7342 115.585 92.6542 114.181 92.6542C112.777 92.6542 111.769 93.7342 111.769 95.1382C111.769 96.5422 112.777 97.6222 114.181 97.6222ZM115.081 114.218H110.293L128.617 89.4862H133.405L115.081 114.218ZM129.481 114.506C126.061 114.506 123.325 111.914 123.325 108.566C123.325 105.218 126.061 102.626 129.481 102.626C132.937 102.626 135.673 105.218 135.673 108.566C135.673 111.914 132.937 114.506 129.481 114.506ZM129.481 111.05C130.885 111.05 131.929 109.97 131.929 108.566C131.929 107.162 130.885 106.082 129.481 106.082C128.077 106.082 127.069 107.162 127.069 108.566C127.069 109.97 128.077 111.05 129.481 111.05Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.553 10.995C109.988 5.21595 105.648 0.121513 99.8546 0.282013C83.3022 0.740595 67.0534 5.22521 52.5417 13.4163C34.9735 23.3326 20.7403 38.2359 11.6421 56.2415C2.54382 74.247 -1.01082 94.5462 1.42763 114.572C3.86607 134.598 12.1881 153.451 25.3413 168.747C38.4945 184.043 55.8882 195.095 75.3228 200.506C94.7573 205.917 115.36 205.443 134.525 199.144C153.69 192.846 170.558 181.006 182.994 165.121C193.266 152 200.134 136.606 203.067 120.31C204.094 114.606 199.707 109.551 193.928 109.116C188.149 108.681 183.179 113.037 182.001 118.712C179.477 130.869 174.181 142.333 166.469 152.183C156.591 164.8 143.195 174.204 127.973 179.206C112.751 184.209 96.3874 184.585 80.9517 180.288C65.5159 175.99 51.7011 167.212 41.2542 155.063C30.8074 142.914 24.1977 127.941 22.261 112.035C20.3242 96.1298 23.1475 80.0074 30.3737 65.7066C37.5999 51.4058 48.9045 39.569 62.858 31.693C73.7527 25.5435 85.8801 22.0243 98.2787 21.3497C104.066 21.0349 109.117 16.7741 109.553 10.995Z",
    fill: "url(#paint0_linear_27_418)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_418",
    x1: -11.6657,
    y1: 91.477,
    x2: 227.168,
    y2: 92.3481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C",
    style: {
      stopColor: "#AA367C",
      stopColor: "color(display-p3 0.6667 0.2118 0.4863)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD",
    style: {
      stopColor: "#4A2FBD",
      stopColor: "color(display-p3 0.2902 0.1843 0.7412)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter75);
export default __webpack_public_path__ + "static/media/meter_75.06038757656ec98633caa95ed727e9e6.svg";
export { ForwardRef as ReactComponent };